import React from 'react';
import * as S from './OfferBlockLoader.styles';

const OfferBlockLoader = () => {
  return (
    <S.OfferBlockLoader>
      <S.offerBlockHeader></S.offerBlockHeader>
      <S.InternalOfferWrapper>
        <S.OfferCouponOuter>
          <S.CouponCode></S.CouponCode>
          <S.CouponCodeApplied></S.CouponCodeApplied>
        </S.OfferCouponOuter>

        <S.OfferDetailsWrap>
          <S.OfferDetails></S.OfferDetails>
          <S.OfferDescription></S.OfferDescription>
        </S.OfferDetailsWrap>
      </S.InternalOfferWrapper>

      <S.InternalOfferWrapper>
        <S.OfferCouponOuter>
          <S.CouponCode></S.CouponCode>
          <S.CouponCodeApplied></S.CouponCodeApplied>
        </S.OfferCouponOuter>

        <S.OfferDetailsWrap>
          <S.OfferDetails></S.OfferDetails>
          <S.OfferDescription></S.OfferDescription>
        </S.OfferDetailsWrap>
      </S.InternalOfferWrapper>

      <S.PromoCodeWrapper>
        <S.ViewAllPromoWrap>
          <S.EnterPromo></S.EnterPromo>
          <S.ViewAllPromo></S.ViewAllPromo>
        </S.ViewAllPromoWrap>

        <S.EnterPromoWrapDiv>
          <S.EnterPromoInnerWrapDiv>
            <S.PromoEnterInput type="text" placeholder="Got A Promocode? Enter" />
          </S.EnterPromoInnerWrapDiv>
          <S.ArrowRightOuter>
            <S.ArrowRightWrap />
          </S.ArrowRightOuter>
        </S.EnterPromoWrapDiv>
      </S.PromoCodeWrapper>
    </S.OfferBlockLoader>
  );
};

export default OfferBlockLoader;
